<template minapp='mpx' xlang='wxml'>
  <view 
  class="es-cell custom-class"
  wx:class="{{classnames}}"     
  bindtap="handleClick"
  hover-class='{{isLink ? "es-cell--hover" : "none"}}'
  wx:style="{{{color: customStyle}}}"
  >

    <es-icon 
    wx:style="{{iconColorStyle}}"
    class="es-cell__left custom-left-icon"
    wx:if="{{icon}}"
    name="{{icon}}"
    size='14'
    bind:click='clickLeftIcon'
    >
    </es-icon>
    <slot wx:else name='icon'></slot>
    
    <view 
    class="es-cell__title custom-title" 
    wx:style="{{width}}"
    wx:if="{{title || useTitle}}"
    >
      <text wx:if="{{title}}">{{title}}</text>
      <slot wx:else name='title'></slot>
      <view class="es-cell__label custom-label" wx:if="{{label || useLabel}}">
        <text wx:if="{{ label }}">{{ label }}</text>
        <slot wx:else name="label" />
      </view>
    </view>

    <view 
    class="es-cell__value custom-value" 
    wx:style="{{ styles }}">
      <block wx:if="{{ value || value === 0 }}">{{ value }}</block>
      <slot wx:else></slot>
    </view>

    <es-icon 
    class="es-cell__right custom-right-icon'"
    wx:if="{{isLink}}"
    name="{{rightIcon}}"
    size='14'
    >
    </es-icon>
    <slot name='icon-right'></slot>
    <slot name='extra'></slot>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    classes: ['custom-left-icon', 'custom-right-icon', 'custom-title', 'custom-value', 'custom-label'],
    props: {
      title: String,
      label: String,
      isLink: Boolean,
      useLabel: Boolean,
      icon: String,
      iconColor: String,
      customStyle: String,
      useTitle: {
        type: Boolean,
        value: false
      },
      border: {
        type: Boolean,
        value: true
      },
      value: null,
      titleWidth: {
        type: String,
        value: '70px'
      },
      rightIcon: {
        type: String,
        value: 'angle-right'
      },
      align: {
        type: String,
        value: 'left'
      }
    },

    computed: {
      width() {
        const { titleWidth } = this
        return {
          minWidth: titleWidth
        }
      },
      classnames() {
        return {
          'es-cell--border': this.border
        }
      },
      styles() {
        const { align, useTitle } = this
        return {
          'text-align': align
        }
      },
      iconColorStyle() {
        return {
          color: this.iconColor
        }
      }
    },

    methods: {
      handleClick(e) {
        this.$trigger('click', e)
      },
      clickLeftIcon() {
        this.$trigger('leftClick')
      }
    }
  })
</script>

<style lang='stylus' src='./style.styl'></style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-icon': '../icon/index'
    }
  }
</script>

